import {fromJS, Map} from 'immutable';
import {
  LOAD_LESSON_PLAN_FULFILLED,
  LOAD_LESSON_PLAN_PENDING,
  LOAD_LESSON_PLAN_REJECTED,
  REGISTER_HOVER_STATE,
  RESET_DOWNLOAD_URL,
  SET_DOWNLOAD_URL_FULFILLED,
  SET_DOWNLOAD_URL_PENDING,
  SET_DOWNLOAD_URL_REJECTED,
  UPDATE_HOVER_STATE,
} from '../../actions';

const initialState = new Map({
  downloadUrl: '',
  hoverStates: new Map(),
  loading: false,
  lessonPlan: new Map(),
});

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_DOWNLOAD_URL_PENDING:
    case LOAD_LESSON_PLAN_PENDING:
      return state.set('loading', true);

    case LOAD_LESSON_PLAN_FULFILLED:
      return state.withMutations(map => map.set('loading', false)
          .set('lessonPlan', fromJS(action.payload.data)));

    case SET_DOWNLOAD_URL_FULFILLED:
      return state.withMutations(map => map.set('loading', false)
          .set('downloadUrl', fromJS(action.payload.data)));

    case SET_DOWNLOAD_URL_REJECTED:
    case LOAD_LESSON_PLAN_REJECTED:
      return state.set('loading', false);

    case RESET_DOWNLOAD_URL:
      return state.set('downloadUrl', '');

    case REGISTER_HOVER_STATE:
      return state.setIn(['hoverStates', action.payload], false);

    case UPDATE_HOVER_STATE:
      return state.setIn(['hoverStates', action.payload.id], action.payload.hoverState);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/lessonDetail/reducers/pages/showLessonDetail.js